import { computed } from "vue";
import { useStoreItem } from "../itemStore.store";
import { flowBranchItemStructure, useFlowBranchStore } from "./flowBranches.store";
import { useTargetStore } from "../target/targets.store";
import { useResourceStore } from "../resource/resources.store";
import { useFlowStore } from "./flows.store";
import GraphModel from "../relation/GraphModel";
import { getFormulaPoints } from "../relation/Relation";


export const useFlowBranch = useStoreItem(flowBranchItemStructure, useFlowBranchStore, (_flowBranch, _store) => {
  const targetStore = useTargetStore();
  const resourceStore = useResourceStore();

  const element = computed(() => {
    const flowBranch = _flowBranch.value;
    if (!flowBranch) return null;
    const type = flowBranch.elementType;
    const id = flowBranch.elementId;
    if (type === "target") return targetStore.items[id];
    if (type === "resource") return resourceStore.items[id];
    return null;
  });

  const flow = computed(() => {
    const flowBranch = _flowBranch.value;
    if (!flowBranch) return null;
    return useFlowStore().items[flowBranch.flowId];
  });

  const flowCalculatedValue = computed(() => {
    if (!flow.value)
      return { minValue: 0, maxValue: 0, value: 0, unit: "", unitValid: true, valid: false };
    return useFlowStore().expressionValues[flow.value.uid];
  });

  const graphModel = computed(() => {
    const flowBranch = _flowBranch.value;
    if (!flowBranch) return null;
    let curvePoints = flowBranch.curvePoints;
    if (flowBranch.curveType === "formula") {
      curvePoints = getInputFormulaPoints(flowBranch.formula);
    }
    try {
      return new GraphModel(curvePoints);
    } catch (e) {
      console.error("Error creating graph model", e, curvePoints);
      return null;
    }
  });

  const flowSpan = computed(() => {
    const calculated = flowCalculatedValue.value;
    // TODO: Do better range calculation
    if (!calculated.minValue || !calculated.maxValue) return 100;
    return calculated.maxValue - calculated.minValue;
  });
  
  const xStepSize = computed(() => {
    if (flowSpan.value < 1) return flowSpan.value / 10;
    const optimalSize = Math.ceil(flowSpan.value / 10);
    return flowSpan.value <= 10 ? 1 : optimalSize;
  });

  function getInputFormulaPoints(formula: string) {
    const calculated = flowCalculatedValue.value;
    // TODO: Do better point calculation...
    return getFormulaPoints(formula, xStepSize.value / 4, calculated.minValue ?? 0, calculated.maxValue ?? 100);
  }

  return {
    element,
    flow,
    graphModel,
    getFormulaPoints: getInputFormulaPoints
  }
});
